<template>
<v-card>
  <v-card-title>
    <span class="headline">{{ formTitle }}</span>
  </v-card-title>
  
  <v-card-text>
    <v-container>
      <v-row justify="center">
        <v-col>
          <v-text-field
            v-model="editedItem.title"
            label="Song title"
            autocomplete="off"
          ></v-text-field>
          
          <v-autocomplete
            v-model="editedItem.performerID"
            :loading="performersLoading"
            :items="performers"
            :search-input.sync="performersSearch"
            cache-items
            flat
            hide-no-data
            hide-details
            label="Select Performer"
            item-text="name"
            item-value="id"
          ></v-autocomplete>
          
          <CategoriesAutocomplete
            v-model="editedItem.categories"
            :categories.sync="categories"
          ></CategoriesAutocomplete>
        </v-col>
      </v-row>
    </v-container>
  </v-card-text>
  
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
    <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import apiClient from "@/utils/apiClient";
import CategoriesAutocomplete from "@/components/CategoriesAutocomplete";

export default {
  name: "SongEditCard",
  components: {CategoriesAutocomplete},
  props: [
    "save",
    "close",
    "performers",
    "categories",
    "editedItem",
    "defaultItem",
  ],
  data: () => ({
    performersLoading: false,
    performersSearch: "",
  }),
  watch: {
    performersSearch(val) {
      val && this.queryPerformers(val);
    },
  },
  methods: {
    queryPerformers(filter) {
      const options = { filter };
      this.performersLoading = true;
      apiClient
        .getPerformers(options)
        .then((response) => {
          this.performers = response.data.records;
          this.performersLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.performersLoading = false;
        });
    },
  },
};
</script>
